<template>
    <dashboard>
        <row>
            <panel>
                <h3 slot="title">Users</h3>
                <template slot="buttons">
                    <app-button size="small" @click="showAddUser = true">Add User</app-button>
                </template>

                <user-table
                    ref="course-student-table"
                    :items="users"
                    :attendable="course"
                    :sort-by="sort_by"
                    :columns="['first_name','last_name','email']"
                    attendable-type="course"
                    @sort-change="sortChange" />

                <pagination
                    :current-page="page"
                    :page-size="per_page"
                    :total="total"
                    layout="prev, pager, next, total"
                    @current-change="pageChange"/>
            </panel>
        </row>

        <modal v-model="showAddUser">
            <course-add-user :course="course" @reload="getUsers(getParameters())"/>
        </modal>
    </dashboard>
</template>

<script>
import table from '@/mixins/table'
import User from '@/store/models/User'

import UserTable from '../User/UserTable'
import CourseAddUser from './CourseAddUser'

export default {
    name: 'page-course-users',
    components: {
        UserTable,
        CourseAddUser
    },
    mixins: [table],
    props: ['course'],
    data() {
        return {
            showAddUser: false,
            relation: 'assignedCourses',
            tableParamKeys: ['relation', 'relation_uuid'],
            users: [],
            total: 0
        }
    },
    computed: {
        relation_uuid() {
            return this.course.uuid
        }
    },
    mounted() {
        this.getUsers(this.getParameters())
    },
    methods: {
        getUsers(params) {
            User.$fetch({
                graphql: 'relation',
                variables: params
            }).then(({ data, raw }) => {
                this.users = data
                this.total = raw.total
            })
        },
        paramsChanged(params) {
            this.getUsers(params)
        }
    }
}
</script>

<style lang="stylus"></style>
